window.app.factory("$calendar", [
  function() {
    return function(scope) {
      return {
        isOpen: false,
        close: function(e, state, stateParams) {
          if (this.isOpen) {
            this.isOpen = false;
          }
          if (e) {
            e.preventDefault();
          }
          if (state) {
            // $scope.timesheetLoading = true;
            var params = {};
            for (var param in stateParams) {
              if (param in scope.$state.params) {
                params[param] = stateParams[param];
              }
            }
            scope.go(state, params);
          }
        },
        open: function(e) {
          if (!this.isOpen) {
            this.isOpen = true;
          }
          e.stopPropagation();
        },
        toggle: function(e) {
          if (this.isOpen) {
            this.close(e);
          } else {
            this.open(e);
          }
        }
      };
    };
  }
]);



// WEBPACK FOOTER //
// ./src/services/calendar.js